// Brand tokens sampled from https://arkose.com/ (2026-07-23): purple #841BF3 is
// their verified accent (cart badge, primary CTA for the climbing vertical),
// #2D2926 the dark neutral used for nav/dark sections. Orange/green/teal are
// the per-vertical accents (cantine/shop/studio) from their Bootstrap overrides,
// reused here for MUI's warning/success/info semantics.
//
// Headings use Adobe Fonts "Roc Grotesk Wide" / body "Roc Grotesk" — those are
// licensed to arkose.com's own Typekit kit and can't be hotlinked from another
// domain, so we fall back to a similar-feeling grotesk sans until/unless this
// app gets its own font license.
const arkose = {
  name: 'arkose',
  colors: {
    primary: '#841BF3',
    primaryContrast: '#FFFFFF',
    secondary: '#2D2926',
    secondaryContrast: '#FFFFFF',
    background: '#FFFFFF',
    text: '#212529',
    textSecondary: '#6C757D',
    success: '#41695B',
    warning: '#E04403',
    error: '#880000',
    info: '#81B4BF',
  },
  fontFamily: {
    heading: '"Roc Grotesk Wide", "Helvetica Neue", Arial, sans-serif',
    body: '"Roc Grotesk", "Helvetica Neue", Arial, sans-serif',
  },
};

export default arkose;
